/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Zäkra API 1.0
 * REST API for Zäkra
 * OpenAPI spec version: v1
 */

export type HomeAnchorMappingSkipReasonEnum =
  (typeof HomeAnchorMappingSkipReasonEnum)[keyof typeof HomeAnchorMappingSkipReasonEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HomeAnchorMappingSkipReasonEnum = {
  PostalCodeMissing: 0,
  UnknownPostalCodePrefix: 1,
} as const;
